import { render } from "./HomePage.vue?vue&type=template&id=e254f79a&scoped=true"
const script = {}

import "./HomePage.vue?vue&type=style&index=0&id=e254f79a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e254f79a"]])

export default __exports__